<div class="dialog-wrapper">
  <div class="dialog-header">
    <img src="./assets/images/sbc/{{data.icon}}.svg" />
  </div>
  <div class="dialog-body">
      <h4 class="title">{{ data.title }}</h4>
      <p class="message" [innerHtml]="data.message"></p>
      <div class="sessionTimer" *ngIf="data.icon=='session-timeout'">
        <div class="sessionTime" id="sessionTimer"></div>
        <div class="min">{{data.min}}</div>
      </div>
  </div>
  <div class="dialog-footer">
    <fpx-button btnType="button" className="secondary" clickable (click)="cancel()" label="{{data.cancelLabel}}"></fpx-button>
    <fpx-button btnType="button" className="primary" clickable (click)="ok()" label="{{data.okLabel}}"></fpx-button>
  </div>
</div>
